import { Box, Card, CardContent, Typography } from "@mui/material";
import { NewStyledNetflixButton } from "../Dashboard/Talent/Schedules/EditDeleteAvailability";
import { Icons } from "../assets/icon";

const WalletStatCardUpdated = ({
  title,
  value,
  icon,
  description,
  action,
}: {
  title: string;
  value: number;
  icon: string;
  description: string;
  action?: boolean;
}) => {
  return (
    <Card variant="outlined" sx={{ p: 2, height: "100%", borderRadius: 4 }}>
      <CardContent>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Typography variant="h6">{icon}</Typography>
          <Typography variant="h6">{title}</Typography>
        </Box>
        <Typography variant="h4" fontWeight="bold" gap={1}>
          {value.toLocaleString()}
          <Icons.Coin height={"25px"} width={"25px"} />
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default WalletStatCardUpdated;
